<template>
  <div class="pt-1">

    <v-dialog
      v-model="showDialog"
      max-width="700px"
      persistent
    >
      <v-card class="pa-3">
        <v-form
          v-model="validated"
          ref="organizationEditForm">

          <!-- 基本情報 -->
          <v-text-field
            :label="$t('account.organization')"
            v-model="edit.name"
            required
            :rules="[v => !!v || $t('account.vali-org-name')]"
          ></v-text-field>

          <v-text-field
            :label="$t('account.description')"
            v-model="edit.description"
          ></v-text-field>

          <v-text-field
            :label="$t('account.incharge')"
            v-model="edit.contact"
          ></v-text-field>

          <v-text-field
            :label="$t('account.tel')"
            :rules="phoneRules"
            v-model="edit.phone"
          ></v-text-field>

          <v-text-field
            :label="$t('user-params.email')"
            :rules="emailRules"
            v-model="edit.email"
          ></v-text-field>

          <v-select
            :label="$t('aplix-use-only.customer-category')"
            v-model="edit.customerCategoryId"
            :items="customerCategories"
            item-text="name"
            item-value="customerCategoryId"
            :rules="[v => !!v || $t('validate.select')]"
            required
            auto
          ></v-select>

          <!-- 組織作成制限 -->
          <p>{{$t("organizations.limit-settings")}}</p>
          <v-checkbox
            :label="$t('organizations.no-limit')"
            v-model="edit.createNoLimit"
          ></v-checkbox>

          <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                flat
                @click.native="showDialog=false"
              >
                {{$t('account.cancel')}}
              </v-btn>

              <v-btn
                color="primary"
                class="ml-4"
                @click.prevent="updateOrganization"
                :disabled="!validated"
              >
                {{$t('btn.save')}}
              </v-btn>
          </v-layout>
          <!-- errors -->
          <div v-if="errorMessage" class="red--text">
            <strong>{{errorMessage}}</strong>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import validate from '@/utils/validate.js'
import utils from '@/utils/utils.js'

export default {
  data () {
    return {
      configLimitCreateHierarchy: config.organizationConfig.limitCreateHierarchy,
      edit: {
        organizationId: '',
        name: '',
        contact: '',
        description: '',
        phone: '',
        email: '',
        limitCreateHierarchy: 0,
        createNoLimit: false,
        customerCategoryId: 0
      },
      customerCategories: [],
      validated: false,
      errorMessage: '',
      showDialog: false,
      phoneRules: [
        v => validate.phoneFormat(v) ||
        this.$t('validate.phone-format'),
        v => v.length <= 128 || this.$t('validate.phone-length')
      ],
      emailRules: [
        v => validate.emailFormat(v) ||
            this.$t('account.vali-email-format')
      ]
    }
  },
  methods: {
    init () {
      this.getCustomerCategories()
    },
    getCustomerCategories () {
      http.request('get', '/service2/dashboard/api/CustomerCategories/customerCategoryList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get customerCategories list failed. (' + data.result + ')')
            return
          }
          this.customerCategories = utils.setNameCustomerCategories(this.$t, data.customerCategories)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    startDialog (param) {
      // 一旦バリデーション等をリセット
      this.$refs.organizationEditForm.reset()
      // 値をバインド
      this.edit.organizationId = param.id
      this.edit.name = param.name
      this.edit.contact = param.contact
      this.edit.description = param.description
      this.edit.phone = param.phone
      this.edit.email = param.email
      this.edit.limitCreateHierarchy = parseInt(param.limit_create_hierarchy)
      this.edit.customerCategoryId = parseInt(param.customer_category_id)
      this.setCreateNoLimit()
      // エラーメッセージを初期化
      this.errorMessage = ''
      // ダイアログを表示
      this.showDialog = true
    },
    closeDialog (update) {
      // 更新のために発火
      if (update) {
        this.$emit('child-action')
      }
      this.showDialog = false
    },
    updateOrganization () {
      this.errorMessage = ''
      const params = {
        organizationId: this.edit.organizationId,
        name: this.edit.name,
        contact: this.edit.contact,
        description: this.edit.description,
        phone: this.edit.phone,
        email: this.edit.email,
        limitCreateHierarchy: this.setLimitCreateHierarchy(),
        customerCategoryId: this.edit.customerCategoryId
      }
      http.request('post', '/service2/dashboard/api/Organizations/updatePc', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('update organization data failed. (' + data.result + ')')
            return
          }
          // 成功
          this.closeDialog(true)
        })
        .catch(error => {
          console.log('error', error)
          this.closeDialog()
        })
    },
    setLimitCreateHierarchy () {
      var limitCreateHierarchy = this.configLimitCreateHierarchy.min
      if (this.edit.createNoLimit === true) {
        limitCreateHierarchy = this.configLimitCreateHierarchy.max
      }
      return limitCreateHierarchy
    },
    setCreateNoLimit () {
      console.log(this.configLimitCreateHierarchy.max, this.edit.limitCreateHierarchy)
      if (this.configLimitCreateHierarchy.max === this.edit.limitCreateHierarchy) {
        this.edit.createNoLimit = true
      }
    },
    showError (error) {
      this.errorMessage = 'failed. (' + error + ')'
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>

 </style>



// WEBPACK FOOTER //
// OrganizationEdit.vue?2a822b12